export const styles = [
    { "a": "卂", "b": "乃", "c": "匚", "d": "ᗪ", "e": "乇", "f": "千", "g": "Ꮆ", "h": "卄", "i": "丨", "j": "ﾌ", "k": "Ҝ", "l": "ㄥ", "m": "爪", "n": "几", "o": "ㄖ", "p": "卩", "q": "Ɋ", "r": "尺", "s": "丂", "t": "ㄒ", "u": "ㄩ", "v": "ᐯ", "w": "山", "x": "乂", "y": "ㄚ", "z": "乙" },
///////////////////////////////////////////////////////////////////////////////
    { "a": "ⓐ", "b": "ⓑ", "c": "ⓒ", "d": "ⓓ", "e": "ⓔ", "f": "ⓕ", "g": "ⓖ", "h": "ⓗ", "i": "ⓘ", "j": "ⓙ", "k": "ⓚ", "l": "ⓛ", "m": "ⓜ", "n": "ⓝ", "o": "ⓞ", "p": "ⓟ", "q": "ⓠ", "r": "ⓡ", "s": "ⓢ", "t": "ⓣ", "u": "ⓤ", "v": "ⓥ", "w": "ⓦ", "x": "ⓧ", "y": "ⓨ", "z": "ⓩ" },
////////////////////////////////////////////////////////////////////////////////
    {"a": "a̳", "b": "b̳", "c": "c̳", "d": "d̳", "e": "e̳", "f": "f̳", "g": "g̳", "h": "h̳", "i": "i̳", "j": "j̳", "k": "k̳", "l": "l̳", "m": "m̳", "n": "n̳", "o": "o̳", "p": "p̳", "q": "q̳", "r": "r̳", "s": "s̳", "t": "t̳", "u": "u̳", "v": "v̳", "w": "w̳", "x": "x̳", "y": "y̳", "z": "z̳"},
//////////////////////////////////////////////////////////////////////////////  
 {"a": "Δ", "b": "β", "c": "Ć", "d": "Đ", "e": "€", "f": "₣", "g": "Ǥ", "h": "Ħ", "i": "Ɨ", "j": "Ĵ", "k": "Ҝ", "l": "Ł", "m": "Μ", "n": "Ň", "o": "Ø", "p": "Ƥ", "q": "Ω", "r": "Ř", "s": "Ş", "t": "Ŧ", "u": "Ữ", "v": "V", "w": "Ŵ", "x": "Ж", "y": "¥", "z": "Ž"},
 ////////////////////////////////////////////////////////////////////////////// 
{"a": "ꋫ", "b": "ꃃ", "c": "ꏸ", "d": "ꁕ", "e": "ꍟ", "f": "ꄘ", "g": "ꁍ", "h": "ꑛ", "i": "ꂑ", "j": "ꀭ", "k": "ꀗ", "l": "꒒", "m": "ꁒ", "n": "ꁹ", "o": "ꆂ", "p": "ꉣ", "q": "ꁸ", "r": "꒓", "s": "ꌚ", "t": "꓅", "u": "ꐇ", "v": "ꏝ", "w": "ꅐ", "x": "ꇓ", "y": "ꐟ", "z": "ꁴ"},
//////////////////////////////////////////////////////////////////////////////  
 {"a": "ꍏ", "b": "ꌃ", "c": "ꉓ", "d": "ꀸ", "e": "ꍟ", "f": "ꎇ", "g": "ꁅ", "h": "ꃅ", "i": "ꀤ", "j": "ꀭ", "k": "ꀘ", "l": "꒒", "m": "ꂵ", "n": "ꈤ", "o": "ꂦ", "p": "ꉣ", "q": "ꆰ", "r": "ꋪ", "s": "ꌗ", "t": "꓄", "u": "ꀎ", "v": "ꃴ", "w": "ꅏ", "x": "ꊼ", "y": "ꌩ", "z": "ꁴ"},
//////////////////////////////////////////////////////////////////////////////  
{
        "a": "ꋬ", "b": "ꃳ", "c": "ꉔ", "d": "꒯", "e": "ꏂ", "f": "ꊰ", "g": "ꍌ", "h": "ꁝ", "i": "꒐", "j": "꒻", "k": "ꀘ", "l": "꒒", "m": "ꂵ", "n": "ꋊ", "o": "ꄲ", "p": "ꉣ", "q": "ꆰ", "r": "ꋪ", "s": "ꇙ", "t": "꓄", "u": "꒤", "v": "꒦", "w": "ꅐ", "x": "ꉧ", "y": "ꌦ", "z": "ꁴ"
    },
//////////////////////////////////////////////////////////////////////////////  

    {
        a: "ᗩ", b: "ᗷ", c: "ᑕ", d: "ᗪ", e: "ᗴ", f: "ᖴ", g: "Ǥ", h: "ᕼ", i: "Ꭵ", j: "ᒎ", k: "ᛕ", l: "ᒪ", m: "ᗰ", n: "ᑎ", o: "ᗝ", p: "ᑭ", q: "Ɋ", r: "ᖇ", s: "ᔕ", t: "丅", u: "ᑌ", v: "ᐯ", w: "ᗯ", x: "᙭", y: "Ƴ", z: "乙"
    },
//////////////////////////////////////////////////////////////////////////////  

    {"a": "Ă", "b": "β", "c": "Č", "d": "Ď", "e": "Ĕ", "f": "Ŧ", "g": "Ğ", "h": "Ĥ", "i": "Ĩ", "j": "Ĵ", "k": "Ķ", "l": "Ĺ", "m": "М", "n": "Ń", "o": "Ő", "p": "Р", "q": "Q", "r": "Ŕ", "s": "Ś", "t": "Ť", "u": "Ú", "v": "V", "w": "Ŵ", "x": "Ж", "y": "Ŷ", "z": "Ź"},
//////////////////////////////////////////////////////////////////////////////  

    {"a": "Λ", "b": "Ϧ", "c": "ㄈ", "d": "Ð", "e": "Ɛ", "f": "F", "g": "Ɠ", "h": "н", "i": "ɪ", "j": "ﾌ", "k": "Қ", "l": "Ł", "m": "௱", "n": "Л", "o": "Ø", "p": "þ", "q": "Ҩ", "r": "尺", "s": "ら", "t": "Ť", "u": "Ц", "v": "Ɣ", "w": "Ɯ", "x": "χ", "y": "Ϥ", "z": "Ẕ"},
//////////////////////////////////////////////////////////////////////////////  

    {"a": "ƛ", "b": "Ɓ", "c": "Ƈ", "d": "Ɗ", "e": "Є", "f": "Ƒ", "g": "Ɠ", "h": "Ӈ", "i": "Ɩ", "j": "ʆ", "k": "Ƙ", "l": "Լ", "m": "M", "n": "Ɲ", "o": "Ơ", "p": "Ƥ", "q": "Ƣ", "r": "Ʀ", "s": "Ƨ", "t": "Ƭ", "u": "Ʋ", "v": "Ɣ", "w": "Ɯ", "x": "Ҳ", "y": "Ƴ", "z": "Ȥ"},
//////////////////////////////////////////////////////////////////////////////  

    {"a": "Թ", "b": "Յ", "c": "Շ", "d": "Ժ", "e": "ȝ", "f": "Բ", "g": "Գ", "h": "ɧ", "i": "ɿ", "j": "ʝ", "k": "ƙ", "l": "ʅ", "m": "ʍ", "n": "Ռ", "o": "Ծ", "p": "ρ", "q": "φ", "r": "Ր", "s": "Տ", "t": "Ե", "u": "Մ", "v": "ע", "w": "ա", "x": "Ճ", "y": "Վ", "z": "Հ"},
//////////////////////////////////////////////////////////////////////////////  

    {"a": "α", "b": "ɓ", "c": "૮", "d": "∂", "e": "ε", "f": "ƒ", "g": "ɠ", "h": "ɦ", "i": "เ", "j": "ʝ", "k": "ҡ", "l": "ℓ", "m": "ɱ", "n": "ɳ", "o": "σ", "p": "ρ", "q": "φ", "r": "૨", "s": "ร", "t": "ƭ", "u": "µ", "v": "ѵ", "w": "ω", "x": "א", "y": "ყ", "z": "ƶ"},
//////////////////////////////////////////////////////////////////////////////  

    {"a": "[a̲̅]", "b": "[b̲̅]", "c": "[c̲̅]", "d": "[d̲̅]", "e": "[e̲̅]", "f": "[f̲̅]", "g": "[g̲̅]", "h": "[h̲̅]", "i": "[i̲̅]", "j": "[j̲̅]", "k": "[k̲̅]", "l": "[l̲̅]", "m": "[m̲̅]", "n": "[n̲̅]", "o": "[o̲̅]", "p": "[p̲̅]", "q": "[q̲̅]", "r": "[r̲̅]", "s": "[s̲̅]", "t": "[t̲̅]", "u": "[u̲̅]", "v": "[v̲̅]", "w": "[w̲̅]", "x": "[x̲̅]", "y": "[y̲̅]", "z": "[z̲̅]"}
,
//////////////////////////////////////////////////////////////////////////////  

{a: "⁅a⁆", b: "⁅b⁆", c: "⁅c⁆", d: "⁅d⁆", e: "⁅e⁆", f: "⁅f⁆", g: "⁅g⁆", h: "⁅h⁆", i: "⁅i⁆", j: "⁅j⁆", k: "⁅k⁆", l: "⁅l⁆", m: "⁅m⁆", n: "⁅n⁆", o: "⁅o⁆", p: "⁅p⁆", q: "⁅q⁆", r: "⁅r⁆", s: "⁅s⁆", t: "⁅t⁆", u: "⁅u⁆", v: "⁅v⁆", w: "⁅w⁆", x: "⁅x⁆", y: "⁅y⁆", z: "⁅z⁆"},
//////////////////////////////////////////////////////////////////////////////  

{
        "a": "卂",
        "b": "乃",
        "c": "匚",
        "d": "口",
        "e": "乇",
        "f": "下",
        "g": "厶",
        "h": "卄",
        "i": "工",
        "j": "丁",
        "k": "长",
        "l": "乚",
        "m": "从",
        "n": "𠘨",
        "o": "口",
        "p": "尸",
        "q": "Ɋ",
        "r": "尺",
        "s": "丂",
        "t": "丅",
        "u": "凵",
        "v": "リ",
        "w": "山",
        "x": "乂",
        "y": "丫",
        "z": "乙"
      }
,      
//////////////////////////////////////////////////////////////////////////////  

    {
        a: "ﾑ", b: "乃", c: "ᄃ", d: "り", e: "乇", f: "ｷ", g: "ム", h: "ん", i: "ﾉ", j: "ﾌ", k: "ズ", l: "ﾚ", m: "ѫ", n: "刀", o: "の", p: "ｱ", q: "ゐ", r: "尺", s: "丂", t: "ｲ", u: "ひ", v: "√", w: "W", x: "ﾒ", y: "ﾘ", z: "乙"
    },
//////////////////////////////////////////////////////////////////////////////  


    {"a": "🄰","b": "🄱","c": "🄲","d": "🄳","e": "🄴","f": "🄵","g": "🄶","h": "🄷","i": "🄸","j": "🄹","k": "🄺","l": "🄻","m": "🄼","n": "🄽","o": "🄾","p": "🄿","q": "🅀","r": "🅁","s": "🅂","t": "🅃","u": "🅄","v": "🅅","w": "🅆","x": "🅇","y": "🅈","z": "🅉"
      },
//////////////////////////////////////////////////////////////////////////////  

      {'a': 'ɐ','b': 'q','c': 'ɔ','d': 'p','e': 'ǝ','f': 'ɟ','g': 'ƃ','h': 'ɥ','i': 'ı','j': 'ɾ','k': 'ʞ','l': 'l','m': 'ɯ','n': 'u','o': 'o','p': 'd','q': 'b','r': 'ɹ','s': 's','t': 'ʇ','u': 'n','v': 'ʌ','w': 'ʍ','x': 'x','y': 'ʎ',
        'z': 'z'
    },
//////////////////////////////////////////////////////////////////////////////  


    {a: 'ค', b: '๒', c: 'ς', d: '๔', e: 'є', f: 'Ŧ', g: 'ﻮ', h: 'ђ', i: 'เ', j: 'ן', k: 'к', l: 'ɭ', m: '๓', n: 'ภ', o: '๏', p: 'ק', q: 'ợ', r: 'г', s: 'ร', t: 'Շ', u: 'ย', v: 'ש', w: 'ฬ', x: 'א', y: 'ץ', z: 'չ'},
    {a: 'α', b: 'Ⴆ', c: 'ƈ', d: 'ԃ', e: 'ҽ', f: 'ϝ', g: 'ɠ', h: 'ԋ', i: 'ι', j: 'ʝ', k: 'ƙ', l: 'ʅ', m: 'ɱ', n: 'ɳ', o: 'σ', p: 'ρ', q: 'ϙ', r: 'ɾ', s: 'ʂ', t: 'ƚ', u: 'υ', v: 'ʋ', w: 'ɯ', x: 'x', y: 'ყ', z: 'ȥ'},
//////////////////////////////////////////////////////////////////////////////  


    {a: 'ǟ', b: 'ɮ', c: 'ƈ', d: 'ɖ', e: 'ɛ', f: 'ʄ', g: 'ɢ', h: 'ɦ', i: 'ɨ', j: 'ʝ', k: 'ӄ', l: 'ʟ', m: 'ʍ', n: 'ռ', o: 'օ', p: 'ք', q: 'զ', r: 'ʀ', s: 'ֆ', t: 'ȶ', u: 'ʊ', v: 'ʋ', w: 'ա', x: 'Ӽ', y: 'ʏ', z: 'ʐ'},

//////////////////////////////////////////////////////////////////////////////  

   
    {a: 'ค', b: '๖', c: '¢', d: '໓', e: 'ē', f: 'ງ', g: 'hi', h: 'ว', i: 'k', j: 'l', k: '๓', l: 'ຖ', m: '໐', n: 'p', o: '๑', p: 'r', q: 'Ş', r: 't', s: 'น', t: 'ง', u: 'ຟ', v: 'x', w: 'ฯ', x: 'ຊ', y: "ყ", z: 'ʑ'},

//////////////////////////////////////////////////////////////////////////////  

    {a: 'Ă', b: 'β', c: 'Č', d: 'Ď', e: 'Ĕ', f: 'Ŧ', g: 'Ğ', h: 'Ĥ', i: 'Ĩ', j: 'Ĵ', k: 'Ķ', l: 'Ĺ', m: 'М', n: 'Ń', o: 'Ő', p: 'Р', q: 'Q', r: 'Ŕ', s: 'Ś', t: 'Ť', u: 'Ú', v: 'V', w: 'Ŵ', x: 'Ж', y: 'Ŷ', z: 'Ź'},

//////////////////////////////////////////////////////////////////////////////  

    {   a: 'ą',  b: 'ც',  c: 'ƈ',  d: 'ɖ',  e: 'ɛ',  f: 'ʄ',  g: 'ɠ',  h: 'ɦ',  i: 'ı',  j: 'ʝ',  k: 'ƙ',  l: 'ʅ',  m: 'ɱ',  n: 'ŋ',  o: 'ơ',  p: '℘',  q: 'զ',  r: 'ཞ',  s: 'ʂ',  t: 'ƚ',  u: 'ʊ',  v: 'ʋ',  w: 'ų',  x: 'ჯ',  y: 'ყ',  z: 'ʑ'},

//////////////////////////////////////////////////////////////////////////////  

    {a: "Д",b: "Б",c: "C",d: "D",e: "Ξ",f: "F",g: "G",h: "H",i: "I",j: "J",k: "Ҝ",l: "L",m: "M",n: "И",o: "Ф",p: "P",q: "Ǫ",r: "Я",s: "S",t: "Γ",u: "Ц",v: "V",w: "Щ",x: "Ж",y: "У",z: "Z"
      }
,      
//////////////////////////////////////////////////////////////////////////////  

    {a: "а",b: "б",c: "c",d: "д",e: "ё",f: "f",g: "g",h: "н",i: "ї",j: "j",k: "к",l: "г",m: "ѫ",n: "п",o: "ѳ",p: "p",q: "ф",r: "я",s: "$",t: "т",u: "ц",v: "ѵ",w: "щ",x: "ж",y: "ч",z: "з"
    },
//////////////////////////////////////////////////////////////////////////////  

    {1: "①","2": "②","3": "③","4": "④","5": "⑤","6": "⑥","7": "⑦","8": "⑧","9": "⑨","0": "⓪"
    },
    {1: "Ɩ","2": "ᄅ","3": "Ɛ","4": "ㄣ","5": "ϛ","6": "9","7": "ㄥ","8": "8","9": "6","0": "0"
    },
];

export const symbols = [
    {
        "left": "乡",
        "right": "乡"
    },
    {
        "left": "梦",
        "right": "梦"
    },
    {
        "left": "؄",
        "right": "؄"
    },
    {
        "left": "숬",
        "right": "숬"
    },
    {
        "left": "本",
        "right": "本"
    },
    {
        "left": "人",
        "right": "人"
    },
    {
        "left": "大",
        "right": "大"
    },
    {
        "left": "炎",
        "right": "炎"
    },
    {
        "left": "父",
        "right": "父"
    },
    {
        "left": "艾",
        "right": "艾"
    },
    {
        "left": "★彡",
        "right": "彡★"
    },
    {
        "left": "💤📿",
        "right": "📿💤"
    },
    {
        "left": "⚡",
        "right": "⚡"
    },
    {
        "left": "✞☬",
        "right": "☬✞"
    },
    {
        "left": "円",
        "right": "円"
    },
    {
        "left": "元",
        "right": "元"
    },
    {
        "left": "҂",
        "right": "҂"
    },
    {
        "left": "✞༒",
        "right": "༒✞"
    },
    {
        "left": "✞☠︎",
        "right": "☠︎✞"
    },
    {
        "left": "▄︻デ",
        "right": "══━一"
    },
    {
        "left": "✞✞",
        "right": "✞✞"
    },
    {
        "left": "✞ঔৣ",
        "right": "ঔৣ✞"
    },
    {
        "left": "༺",
        "right": "༻"
    },
    {
        "left": "༒•",
        "right": "•༒"
    },
    {
        "left": "╰☆☆",
        "right": "☆☆╮"
    },
    {
        "left": ".o0×X×0o.",
        "right": ".o0×X×0o."
    },
    {
        "left": "—(••÷",
        "right": "÷••)—"
    },
    {
        "left": "◦•●◉✿",
        "right": "✿◉●•◦"
    },
    {
        "left": "╚»★«╝",
        "right": "╚»★«╝"
    },
    {
        "left": "-·=»‡«=·-",
        "right": "-·=»‡«=·-"
    },
    {
        "left": ".•♫•♬•",
        "right": "•♬•♫•."
    },
    {
        "left": "『",
        "right": "』"
    },
    {
        "left": "〘",
        "right": "〙"
    },
    {
        "left": "【",
        "right": "】"
    },
    {
        "left": "《",
        "right": "》"
    },
    {
        "left": "「",
        "right": "」"
    },
    {
        "left": "シ",
        "right": "ツ"
    },
    {
        "left": "ヅ",
        "right": "ヅ"
    },
    {
        "left": "々",
        "right": "々"
    },
    {
        "left": "〩",
        "right": "〩"
    },
    {
        "left": "ズ",
        "right": "ズ"
    },
    {
        "left": "き",
        "right": "き"
    },
    {
        "left": "×",
        "right": "×"
    },
    {
        "left": "メ",
        "right": "メ"
    },
    {
        "left": "乄",
        "right": "乄"
    },
    {
        "left": "ヤ",
        "right": "ヤ"
    },
    {
        "left": "〆",
        "right": "〆"
    },
    {
        "left": "٭",
        "right": "٭"
    },
    {
        "left": "٪",
        "right": "٪"
    },
    {
        "left": "٠١٠",
        "right": "٠١٠"
    },
    {
        "left": "ノ",
        "right": "ノ"
    },
    {
        "left": "乀",
        "right": "乀"
    },
    {
        "left": "乁",
        "right": "乁"
    },
    {
        "left": "乛",
        "right": "乛"
    },
    {
        "left": "๛",
        "right": "๛"
    },
    {
        "left": "三",
        "right": "三"
    },
    {
        "left": "亗",
        "right": "亗"
    },
    {
        "left": "卍",
        "right": "卍"
    },
    {
        "left": "۝",
        "right": "۝"
    },
    {
        "left": "¤",
        "right": "¤"
    },
    {
        "left": "气",
        "right": "气"
    },
    {
        "left": "金",
        "right": "金"
    },
    {
        "left": "帝",
        "right": "帝"
    },
    {
        "left": "彡",
        "right": "彡"
    },
    
    {
        "left": "义",
        "right": "义"
    },
    {
        "left": "个",
        "right": "个"
    },
    {
        "left": "卄",
        "right": "卄"
    },
    {
        "left": "웃",
        "right": "웃"
    },
    {
        "left": "ʘ͜ʖʘ",
        "right": "ʘ͜ʖʘ"
    },
    {
        "left": "๏̯͡๏",
        "right": "๏̯͡๏"
    },
    {
        "left": "(‡▼益▼)",
        "right": "(▼益▼‡)"
    },
    {
        "left": "(╬⓪益⓪)",
        "right": "(⓪益⓪╬)"
    },
    {
        "left": "(ꐦ ಠ皿ಠ )",
        "right": "( ಠ皿ಠꐦ)"
    },
    {
        "left": "(ʘ言ʘ╬)",
        "right": "(╬ʘ言ʘ)"
    },
    {
        "left": "ಠ益ಠ╬",
        "right": "╬ಠ益ಠ"
    },
    {
        "left": "(#ಠQಠ#)",
        "right": "(#ಠQಠ#)"
    },
    {
        "left": "(ᗒᗣᗕ)",
        "right": "(ᗒᗣᗕ)"
    },
    {
        "left": "♞",
        "right": "♞"
    },
    {
        "left": "🕱",
        "right": "🕱"
    },
    {
        "left": "🔨",
        "right": "🔨"
    },
    {
        "left": "么",
        "right": "么"
    },
    {
        "left": "ㅶ",
        "right": "ㅶ"
    },
    {
        "left": "ツ",
        "right": "ツ"
    },
    {
        "left": "私",
        "right": "私"
    },
    {
        "left": "٭Ł",
        "right": "٭Ł"
    },
    {
        "left": "®",
        "right": "®"
    },
    {
        "left": "ジ",
        "right": "ジ"
    },
    {
        "left": "Ø",
        "right": "Ø"
    },
    {
        "left": "刁",
        "right": "刁"
    },
    {
        "left": "丶",
        "right": "丶"
    },
    {
        "left": "シ",
        "right": "シ"
    },
    {
        "left": "연",
        "right": "연"
    },
    {
        "left": "Ð",
        "right": "Ð"
    },
    {
        "left": "★",
        "right": "★"
    },
    {
        "left": "✴",
        "right": "✴"
    },
    {
        "left": "❁",
        "right": "❁"
    },
    {
        "left": "☆",
        "right": "☆"
    },
    {
        "left": "✵",
        "right": "✵"
    },
    {
        "left": "❂",
        "right": "❂"
    },
    {
        "left": "♔",
        "right": "♔"
    },
    {
        "left": "♝",
        "right": "♝"
    },
    {
        "left": "♧",
        "right": "♧"
    },
    {
        "left": "♕",
        "right": "♕"
    },
    {
        "left": "♣",
        "right": "♣"
    },
    {
        "left": "♚",
        "right": "♚"
    },
    {
        "left": "♖",
        "right": "♖"
    },
    {
        "left": "♟",
        "right": "♟"
    },
    {
        "left": "♡",
        "right": "♡"
    },
    {
        "left": "♛",
        "right": "♛"
    },
    {
        "left": "ハ",
        "right": "ハ"
    },
    {
        "left": "ク",
        "right": "ク"
    },
    {
        "left": "ほ",
        "right": "ほ"
    },
    {
        "left": "う",
        "right": "う"
    },
    {
        "left": "バ",
        "right": "バ"
    },
    {
        "left": "グ",
        "right": "グ"
    },
    {
        "left": "ぼ",
        "right": "ぼ"
    },
    {
        "left": "ぇ",
        "right": "ぇ"
    },
    {
        "left": "パ",
        "right": "パ"
    },
    {
        "left": "ケ",
        "right": "ケ"
    },
    {
        "left": "ぽ",
        "right": "ぽ"
    },
    {
        "left": "ㄷ",
        "right": "ㄷ"
    },
    {
        "left": "≪",
        "right": "≫"
    },
    {
        "left": "⪻",
        "right": "⪼"
    },
    {
        "left": "◥",
        "right": "◤"
    },
    {
        "left": "୧",
        "right": "୨"
    },
    {
        "left": "⪑",
        "right": "⪒"
    },
    {
        "left": "⪓",
        "right": "⪔"
    },
    {
        "left": "☽",
        "right": "☾"
    },
    {
        "left": "﹄",
        "right": "﹃"
    },
    {
        "left": "ᖫ",
        "right": "ᖭ"
    },
    {
        "left": "ད",
        "right": "ཌ"
    },
    {
        "left": "⸔",
        "right": "⸕"
    },
    {
        "left": "⫷",
        "right": "⫸"
    },
    {
        "left": "▓",
        "right": "▓"
    },
    {
        "left": "▒",
        "right": "▒"
    },
    {
        "left": "░",
        "right": "░"
    },
    {
        "left": "▤",
        "right": "▤"
    },
    {
        "left": "▥",
        "right": "▥"
    },
    {
        "left": "︽",
        "right": "︾"
    },
    {
        "left": "∉",
        "right": "∌"
    },
    {
        "left": "⩻",
        "right": "⩼"
    },
    {
        "left": "⪨",
        "right": "⪩"
    },
    {
        "left": "⁅",
        "right": "⁆"
    },
    {
        "left": "⋉",
        "right": "⋊"
    },
    {
        "left": "⧼",
        "right": "⧽"
    },
    {
        "left": "⦃",
        "right": "⦄"
    },
    {
        "left": "⦅",
        "right": "⦆"
    },
    {
        "left": "⦇",
        "right": "⦈"
    },
    {
        "left": "⦉",
        "right": "⦊"
    },
    {
        "left": "꧁",
        "right": "꧂"
    },
    {
        "left": "𒈞",
        "right": "𒈞"
    },
    {
        "left": "𒆜",
        "right": "𒆜"
    },
    {
        "left": "☆(☢‿☢)☆",
        "right": "☆(☢‿☢)☆"
    },
    {
        "left": "♥‿♥",
        "right": "♥‿♥"
    },
    {
        "left": "ᕦ( ͡° ͜ʖ ͡°)ᕤ",
        "right": "ᕦ( ͡° ͜ʖ ͡°)ᕤ"
    },
    {
        "left": "❀◕ ‿ ◕❀",
        "right": "❀◕ ‿ ◕❀"
    },
    {
        "left": "（╹ェ╹）",
        "right": "（╹ェ╹）"
    },
    {
        "left": "(◠︿◠)",
        "right": "(◠︿◠)"
    },
    {
        "left": "▄︻┻̿═━一",
        "right": "▄︻┻̿═━一"
    },
    {
        "left": "╾━╤デ╦︻",
        "right": "╾━╤デ╦︻"
    },
    {
        "left": "▀̿Ĺ̯▀̿ ̿",
        "right": "▀̿Ĺ̯▀̿ ̿"
    },
    {
        "left": "▄︻̷̿┻̿═━一",
        "right": "▄︻̷̿┻̿═━一"
    },
    {
        "left": "( ͡ᵔ ͜ʖ ͡ᵔ )",
        "right": "( ͡ᵔ ͜ʖ ͡ᵔ )"
    },
    {
        "left": "(ง'̀-'́)ง",
        "right": "(ง'̀-'́)ง"
    },
    {
        "left": "(-’๏_๏’-)",
        "right": "(-’๏_๏’-)"
    },
    {
        "left": "❚█══█❚",
        "right": "❚█══█❚"
    },
    {
        "left": "⚆_⚆",
        "right": "⚆_⚆"
    },
    {
        "left": "⌐╦╦═─",
        "right": "⌐╦╦═─"
    },
    {
        "left": "(•◡•)",
        "right": "(•◡•)"
    },
    {
        "left": "(^Ω^)",
        "right": "(^Ω^)"
    },
    {
        "left": "☀≡☀",
        "right": "☀≡☀"
    },
    {
        "left": "(•ω•)",
        "right": "(•ω•)"
    },
    {
        "left": "⨶‿⨶",
        "right": "⨶‿⨶"
    },
    {
        "left": "ᕙ(◕ਊ◕)ᕗ",
        "right": "ᕙ(◕ਊ◕)ᕗ"
    },
    {
        "left": "(≧◡≦)",
        "right": "(≧◡≦)"
    },
    {
        "left": "ԅ། – ‸ – །ᕗ",
        "right": "ԅ། – ‸ – །ᕗ"
    },
    {
        "left": "(ᵔᴥᵔ)",
        "right": "(ᵔᴥᵔ)"
    },
    {
        "left": "◔̯◔",
        "right": "◔̯◔"
    },
    {
        "left": "(▰˘◡˘▰)",
        "right": "(▰˘◡˘▰)"
    },
    {
        "left": "≧☉_☉≦",
        "right": "≧☉_☉≦"
    },
    {
        "left": "ᕙ(⇀‸↼‶)ᕗ",
        "right": "ᕙ(⇀‸↼‶)ᕗ"
    },
    {
        "left": "¬_¬",
        "right": "¬_¬"
    },
    {
        "left": "㋡",
        "right": "㋡"
    },
    {
        "left": "𓃰",
        "right": "𓃰"
    },
    {
        "left": "♨",
        "right": "♨"
    },
    {
        "left": "⚐",
        "right": "⚐"
    },
    {
        "left": "⚑",
        "right": "⚑"
    },
    {
        "left": "⚒",
        "right": "⚒"
    },
    {
        "left": "⚓",
        "right": "⚓"
    },
    {
        "left": "⚔",
        "right": "⚔"
    },
    {
        "left": "⚘",
        "right": "⚘"
    },
    {
        "left": "⚛",
        "right": "⚛"
    },
    {
        "left": "⚜",
        "right": "⚜"
    },
    {
        "left": "☿",
        "right": "☿"
    },
    {
        "left": "♀",
        "right": "♀"
    },
    {
        "left": "♁",
        "right": "♁"
    },
    {
        "left": "♂",
        "right": "♂"
    },
    {
        "left": "☀",
        "right": "☀"
    },
    {
        "left": "☉",
        "right": "☉"
    },
    {
        "left": "☼",
        "right": "☼"
    },
    {
        "left": "✩",
        "right": "✩"
    },
    {
        "left": "♗",
        "right": "♗"
    },
    {
        "left": "♘",
        "right": "♘"
    },
    {
        "left": "♙",
        "right": "♙"
    },
    {
        "left": "♜",
        "right": "♜"
    },
    {
        "left": "♮",
        "right": "♮"
    },
    {
        "left": "것",
        "right": "것"
    },
    {
        "left": "IㄚI",
        "right": "IㄚI"
    },
    {
        "left": "【≽ܫ≼】",
        "right": "【≽ܫ≼】"
    },
    {
        "left": "₩",
        "right": "₩"
    },
    {
        "left": "₹",
        "right": "₹"
    },
    {
        "left": "妥",
        "right": "妥"
    },
    {
        "left": "楤",
        "right": "楤"
    },
    {
        "left": "橱",
        "right": "橱"
    },
    {
        "left": "源",
        "right": "源"
    },
    {
        "left": "玄",
        "right": "玄"
    },
    {
        "left": "蒙",
        "right": "蒙"
    },
    {
        "left": "螿",
        "right": "螿"
    },
    {
        "left": "西",
        "right": "西"
    },
    {
        "left": "起",
        "right": "起"
    },
    
    {
        "left": "෴",
        "right": "෴"
    },
    {
        "left": "࿐",
        "right": "࿐"
    },
    {
        "left": "ᄽ",
        "right": "ᄽ"
    },
    {
        "left": "ᛋ",
        "right": "ᛋ"
    },
    {
        "left": "ឱ",
        "right": "ឱ"
    },
    {
        "left": "፨",
        "right": "፨"
    },
    {
        "left": "፦",
        "right": "፦"
    },
    {
        "left": "ᚠ",
        "right": "ᚡ"
    },
    {
        "left": "ᚭ",
        "right": "ᚮ"
    },
    {
        "left": "ᚯ",
        "right": "ᚰ"
    },
    {
        "left": "ᛇ",
        "right": "ᛇ"
    },
    {
        "left": "ᛉ",
        "right": "ᛉ"
    },
    {
        "left": "ᛊ",
        "right": "ᛊ"
    },
    {
        "left": "ᛝ",
        "right": "ᛝ"
    },
    {
        "left": "弔",
        "right": "弔"
    },
    {
        "left": "ᛞ",
        "right": "ᛞ"
    },
    {
        "left": "ᛟ",
        "right": "ᛟ"
    },
    {
        "left": "ᛠ",
        "right": "ᛠ"
    },
    {
        "left": "ᛡ",
        "right": "ᛡ"
    },
    {
        "left": "ᛢ",
        "right": "ᛢ"
    },
    {
        "left": "ᛣ",
        "right": "ᛣ"
    },
    {
        "left": "ᛤ",
        "right": "ᛤ"
    },
    {
        "left": "ᛥ",
        "right": "ᛥ"
    },
    {
        "left": "ᛦ",
        "right": "ᛦ"
    },
    {
        "left": "ᛨ",
        "right": "ᛨ"
    },
    {
        "left": "ᛪ",
        "right": "ᛪ"
    },
    {
        "left": "ꀸ",
        "right": "ꀸ"
    },
    {
        "left": "ᚙ",
        "right": "ᚙ"
    },
    {
        "left": "᚜",
        "right": "᚛"
    },
    {
        "left": "𐌰",
        "right": "𐌰"
    }
]





export const symbolsPad = ['『』', '〘〙', '【】', '《》', '「」', '丨', 'シ', 'ツ', 'ヅ', '々', '〩', 'ズ', 'き', '丶', '×', 'メ', '乄', 'ヤ', '〆', '・', '٭', '。', ',', '¹', '٪', '٠١٠', 'ノ', '乀', '乁', '一', '乛', '๛', '三', '亗', '卍', '۝', '¤', '气', '金', '帝', '彡', '乡', '梦', '؄', '숬', '本', '人', '大', '炎', '父', '艾', '义', '个', '卄', '웃', 'ʘ͜ʖʘ', '๏̯͡๏'];
